import { render, staticRenderFns } from "./HRIS-sync.vue?vue&type=template&id=25bd9a82&scoped=true&"
import script from "./HRIS-sync.vue?vue&type=script&lang=js&"
export * from "./HRIS-sync.vue?vue&type=script&lang=js&"
import style0 from "./HRIS-sync.vue?vue&type=style&index=0&id=25bd9a82&lang=scss&scoped=true&"
import style1 from "./HRIS-sync.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bd9a82",
  null
  
)

export default component.exports